import {useEffect, useMemo} from "react";
import GraphicUtils from "../../../../../../utils/graphic-utils.js";
import ReportUtils from "../../../../../../utils/report-utils.js";

export default function SignUserNotifications({ data }) {
    const allSignUserNotificationsChart = useMemo(() => {
        const source = data?.notificationSignByUser || [];

        return {
            totalItems: source.length,
            labels: source.map(item => item.text),
            values: source.map(item => Number(item.value || 0)),
        };
    }, [data]);

    const top10SignUserNotifications = useMemo(() => {
        const source = [...(data?.notificationSignByUser || [])]
            .sort((a, b) => Number(b.value || 0) - Number(a.value || 0))
            .slice(0, 10);

        return {
            labels: source.map(item => item.text),
            values: source.map(item => Number(item.value || 0)),
        };
    }, [data]);

    const chartTitle = allSignUserNotificationsChart.totalItems > 10 ? "Verificações de clones por agente (TOP 10)" : "Verificações de clones por agente";

    useEffect(() => {
        GraphicUtils.barChart(
            "sign-user-notifications",
            top10SignUserNotifications.values,
            top10SignUserNotifications.labels,
        );

        if (allSignUserNotificationsChart.values.some(v => v > 0)) {
            ReportUtils.createExportableTable(
                allSignUserNotificationsChart.labels,
                allSignUserNotificationsChart.values,
                "Verificações por agente",
            );
        }
    }, [top10SignUserNotifications, allSignUserNotificationsChart]);

    return (
        <>
            <div className="chart-report">
                <span className="chart-title">{chartTitle}</span>
                <div id="sign-user-notifications" className="mt-3" />
            </div>
        </>
    )
}